export default "__VITE_PUBLIC_ASSET__6c00ff94__"